import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import Heading from '../ui/Heading';

const ContactInfo = () => {
  return (
    <div>
      <Heading level="3">Contact Information</Heading>
      <div className="mt-6 space-y-6">
        {/* Office Address */}
        <div>
          <h4 className="font-medium text-lg mb-2 flex items-center">
            <FaMapMarkerAlt className="text-gray-400 mr-2" />
            Office Address
          </h4>
          <p className="text-gray-600 ml-7">
            #228/1, 1st Floor, 17th E Main,<br />
            K.H.B. Colony, Koramangala,<br />
            Bengaluru - 560 095,<br />
            India
          </p>
        </div>

        {/* Phone */}
        <div>
          <h4 className="font-medium text-lg mb-2 flex items-center">
            <FaPhoneAlt className="text-gray-400 mr-2" />
            Phone
          </h4>
          <p className="text-gray-600 ml-7">
            Mob: +91 9036026133<br />
            Tel: 080 35878030
          </p>
        </div>

        {/* Email */}
        <div>
          <h4 className="font-medium text-lg mb-2 flex items-center">
            <FaEnvelope className="text-gray-400 mr-2" />
            Email
          </h4>
          <p className="text-gray-600 ml-7">
          <span className="font-medium">General Inquiries:</span> info@vasudharinihomes.com <br />
          <span className="font-medium">Sales & Bookings:</span> sales@vasudharinihomes.com
          </p>
        </div>

        {/* Office Hours */}
        <div>
          <h4 className="font-medium text-lg mb-2 flex items-center">
            <FaClock className="text-gray-400 mr-2" />
            Office Hours
          </h4>
          <p className="text-gray-600 ml-7">
            Monday - Saturday : 10:00 AM - 6:00 PM<br />
            {/* Saturday: 10:00 AM - 2:00 PM<br /> */}
            Sunday : Closed
          </p>
        </div>

        {/* Social Media Links */}
        <div className="pt-4">
          <h4 className="font-medium text-lg mb-4">Connect With Us</h4>
          <div className="flex space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaFacebook size={24} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaYoutube size={24} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaInstagram size={24} />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactInfo;